import { ViewNode } from '../viewTree/nodes/ViewNode';
export class View3dPlugin {
    constructor() {
        this.options = null;
    }
    init(options) {
        this.options = options;
        this.onInit(options);
    }
    onInit(_options) { }
    findNodeByName(name) {
        var _a;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.rootNode))
            return;
        let result = undefined;
        this.options.rootNode.traverse((node) => {
            if (node.name === name) {
                result = node;
            }
        });
        return result;
    }
    findNodeContainer(key) {
        return this.findNodeByName(ViewNode.getContainerNodeName(key));
    }
    findNodeByKey(key) {
        return this.findNodeByName(ViewNode.getContentNodeName(key));
    }
    onDestroy() { }
    onUpdateLayout() { }
    update(_delta) { }
    render() { }
}
//# sourceMappingURL=View3dPlugin.js.map